import React, { Fragment } from "react";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { Form } from "react-bootstrap";

const MCQQuestion = React.memo(({ index, input, onQuestionTextChange, onAddOption, onOptionTextChange, onDeleteOption, onGraceMarkChange, onDifficultyChange, removeHandler }) => {
  return (
    <Fragment>
      <div className="row m-0 mb-2 mt-3">
        <div className="col-12">
          <label>Question No: {index + 1}</label>
        </div>
      </div>

      <div className="row m-0 ">
        <div className="col-12 d-flex  mb-2">
          <input
            className="form-control question custom-input custom-title-color"
            placeholder="Question"
            value={input && input.question}
            onChange={(e) => onQuestionTextChange(input.id, e.target.value)}
          />

          {index > 0 && (
            <button
              type="button"
              title="Remove Question"
              className="btn btn-sm btn-outline-danger ms-4 my-2 pt-1 pb-0"
              onClick={() => removeHandler(input.id)}
            >
              <i className="pi pi-times"></i>
            </button>
          )}
        </div>
      </div>

      {input && input.options.map((opt, i) => (
        <div className="row m-0 pt-2 pb-2" key={i}>
          <div className="col-12 d-flex ">
            <div className="p-inputgroup flex-1 custom-input ">
              <span className="p-inputgroup-addon custom-title-color">
                <Checkbox
                  checked={opt.isAnswer}
                  onChange={(e) =>
                    onOptionTextChange(input.id, opt.id, opt.option, e.target.checked)
                  }
                />
              </span>
              <InputText
                className="custom-input-color"
                placeholder={`Option ${i + 1}`}
                value={opt.option}
                onChange={(e) =>
                  onOptionTextChange(input.id, opt.id, e.target.value, opt.isAnswer)
                }
              />

              {input && input.options.length > 2 && (
                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger my-2  ms-4  pt-1 pb-0"
                  onClick={() => onDeleteOption(input.id, opt.id)}
                >
                  <i className="pi pi-times"></i>
                </button>
              )}
            </div>
          </div>
        </div>
      ))}
      <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-2 mt-2 px-2 mx-1">
        <div
          className=" rounded custom-title-color d-flex gap-2  align-items-center justify-content-center py-2 px-2"

        >
          <div className="">
            <Checkbox
              inputId={`graceMark-${index}`}
              checked={input?.hasGraceMark}
              onChange={(e) => onGraceMarkChange(input.id, e.target.checked)}
            />
          </div>
          <label
            htmlFor={`graceMark-${index}`}
            style={{
              display: "flex",
              alignItems: "center",
              flex: 1,
              whiteSpace: "nowrap",
            }}
          >
            Has Grace Mark?
          </label>
        </div>


        <div className="d-flex align-items-center gap-4">
          <Form style={{ marginBottom: '-32px' }}>
            <Form.Group className="d-flex align-items-center">
              <Form.Check
                className="custom-input ms-5"
                type="checkbox"
                id="custom-switch-easy"
                label="Easy"
                value={1}
                checked={input?.difficulty === 1}
                onChange={(e) => e.target.checked && onDifficultyChange(input.id, 1)}
                style={{ gap: "10px" }}

              />
              <Form.Check
                className="custom-input ms-5"
                type="checkbox"
                id="custom-switch-medium"
                label="Medium"
                value={2}
                checked={input?.difficulty === 2}
                onChange={(e) => e.target.checked && onDifficultyChange(input.id, 2)}
                style={{ gap: "10px" }}

              />
              <Form.Check
                className="custom-input  ms-5"
                type="checkbox"
                id="custom-switch-hard"
                label="Hard"
                value={3}
                checked={input?.difficulty === 3}
                onChange={(e) => e.target.checked && onDifficultyChange(input.id, 3)}
                style={{ gap: "10px" }}

              />
            </Form.Group>
          </Form>

          <button

            className="py-2 btn btn-outline"
            title={input && input.options.length >= 5 ? 'Only 5 options can be added' : 'Add Option'}
            disabled={input && input.options.length >= 5}
            onClick={() => onAddOption(input.id)}
          >
            Add Option
          </button>
        </div>
      </div>

      <hr className="mx-2" />
    </Fragment>
  );
});

export default MCQQuestion;
